/**
 * User survey status
 *
 * @author Matthew Rawson @ 13/02/2018 10:27
 * @type {string}
 */
export const UNSEEN = "unseen"
export const SEEN = "seen"
export const STARTED = "started"
export const FINISHED = "finished"

/** I like to push them into a collection to be able to do quick validation */
export const STATUSES = [UNSEEN, SEEN, STARTED, FINISHED]
